import { useEffect, useState } from 'react';
import { useLang } from '../../../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../../../hooks/use-query-params';
import { ModalProps } from '../../../../../../../components/modal/modal';
import { useAdminsStore } from '../../../../../../../store/use-admins-store';
import { validate } from '../../../../../../../helpers/validate';

export const useCompanyAdminsCreateModal = (props: ModalProps) => {
  const params = useQueryParams().getQueryParams();
  const id = params.adminId;
  const [step, setStep] = useState(1);
  const { admin, postAdmin, putAdmin, list, handleUpdateAdmin, handleResetAdmin } =
    useAdminsStore();
  const { t } = useLang();

  useEffect(() => {
    if (id) {
      const admin = list?.find((item) => String(item.id) === id);
      if (admin) {
        handleUpdateAdmin(admin);
      }
    }
    return () => handleResetAdmin();
  }, [id, list]);

  const isHasNextStep = step < 2;

  const handleNextStep = () => {
    let isValid = true;
    if (step === 1) {
      isValid = validate({
        first_name: { rule: (val) => val.length > 0 },
        last_name: { rule: (val) => val.length > 0 },
        role: { rule: () => !!admin?.role },
        branches: { rule: () => !!admin?.branches?.length },
      });
    }

    if (step === 2) {
      isValid = validate({
        login: { rule: (val) => val.length > 0 },
        password: { rule: (val) => val.length > 0 },
        repeat_password: { rule: (val) => val === admin?.password },
      });
    }

    if (!isValid) return;

    if (isHasNextStep) {
      setStep(step + 1);
    } else {
      try {
        if (id) {
          putAdmin();
        } else {
          postAdmin();
        }
        props.onClose();
      } catch (e) {
        console.error(e);
      }
    }
  };

  const isHasPrevStep = step > 1;

  const handlePrevStep = () => {
    if (isHasPrevStep) {
      setStep(step - 1);
    } else {
      props.onClose();
    }
  };

  return { t, id, step, handleNextStep, handlePrevStep, isHasNextStep, isHasPrevStep };
};
